module.exports = __webpack_public_path__ + "static/media/resultats_sapin2023.d3924ee5.jpg";